import React from 'react';
import './SubTabs.css';
interface SubTab {
  id: string;
  label: string;
  icon?: string;
}
interface SubTabsProps {
  subTabs: SubTab[];
  activeSubTab: string;
  onSubTabChange: (subTabId: string) => void;
  children: React.ReactNode;
}
const SubTabs: React.FC<SubTabsProps> = ({ subTabs, activeSubTab, onSubTabChange, children }) => {
  return (
    <div className="sub-tabs-container">
      <div className="sub-tabs-header">
        {subTabs.map((subTab) => (
          <button
            key={subTab.id}
            type="button"
            className={`sub-tab-button ${activeSubTab === subTab.id ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSubTabChange(subTab.id);
            }}
          >
            {subTab.icon && <span className="sub-tab-icon">{subTab.icon}</span>}
            <span className="sub-tab-label">{subTab.label}</span>
          </button>
        ))}
      </div>
      <div className="sub-tabs-content">
        {children}
      </div>
    </div>
  );
};
export default SubTabs;